module.exports = __webpack_public_path__ + "fa48ac3b05f0d5710ed6d18b131bfaae.pdf";